module.exports = __webpack_public_path__ + "img/山东大学logo.96fe1ac7.png";